import { Link } from "react-router-dom";
import { useUiLang } from "../../../../stores/uiLang";

// Run E2 J2: Help Center hub for Project Explore (K-5), English and Spanish.
// PFL articles (curriculum standards, skill builders, adaptive instructional
// support) are hidden; their routes redirect here. The non-working search box
// is removed. Round 3: "Updating your profile" is unlinked (there is no
// profile page); its route redirects here.
const BASE = "/support/help-center";

const HUB_T = {
  en: {
    title: "Help Center",
    intro: "Short guides for teachers using Project Explore, a K-5 literacy program in English and Spanish.",
    groups: [
      {
        title: "Getting Started",
        links: [
          ["getting-started/creating-your-account", "Creating your account"],
          ["getting-started/logging-in-as-student-or-teacher", "Logging in as a student or teacher"],
          ["getting-started/setting-up-your-first-class", "Setting up your first class"],
          ["getting-started/invite-your-students", "Invite your students"],
          ["getting-started/navigating-the-dashboard", "Navigating the dashboard"],
        ],
      },
      {
        title: "Using Project Explore",
        links: [
          ["using-the-platform/assigning-activities", "Assigning a chapter"],
          ["using-the-platform/viewing-student-progress", "Viewing student progress"],
        ],
      },
      {
        title: "Account & Settings",
        links: [
          ["account-settings/resetting-your-password", "Resetting your password"],
          ["account-settings/managing-notifications", "Managing notifications"],
          ["lti-registration-guide", "LTI Registration Guide"],
          ["account-settings/connecting-your-lms", "Connecting your LMS"],
          ["account-settings/understanding-permissions-and-roles", "Understanding permissions and roles"],
        ],
      },
    ],
    ctaTitle: "Still can't find what you need?",
    ctaText: "Please email our support team and we will get back to you.",
    cta: "Contact Support",
  },
  es: {
    title: "Centro de ayuda",
    intro: "Guías breves para maestros que usan Project Explore, un programa de lectoescritura de K a 5.º grado en inglés y español.",
    groups: [
      {
        title: "Primeros pasos",
        links: [
          ["getting-started/creating-your-account", "Cómo crear tu cuenta"],
          ["getting-started/logging-in-as-student-or-teacher", "Cómo iniciar sesión como estudiante o maestro"],
          ["getting-started/setting-up-your-first-class", "Cómo crear tu primera clase"],
          ["getting-started/invite-your-students", "Cómo agregar a tus estudiantes"],
          ["getting-started/navigating-the-dashboard", "Cómo usar el panel"],
        ],
      },
      {
        title: "Cómo usar Project Explore",
        links: [
          ["using-the-platform/assigning-activities", "Cómo asignar un capítulo"],
          ["using-the-platform/viewing-student-progress", "Cómo ver el progreso de los estudiantes"],
        ],
      },
      {
        title: "Cuenta y configuración",
        links: [
          ["account-settings/resetting-your-password", "Cómo cambiar tu contraseña"],
          ["account-settings/managing-notifications", "Cómo manejar las notificaciones"],
          ["lti-registration-guide", "Guía de registro LTI"],
          ["account-settings/connecting-your-lms", "Cómo conectar tu LMS"],
          ["account-settings/understanding-permissions-and-roles", "Permisos y roles"],
        ],
      },
    ],
    ctaTitle: "¿No encuentras lo que necesitas?",
    ctaText: "Por favor, escribe a nuestro equipo de ayuda y te responderemos.",
    cta: "Contactar a soporte",
  },
};

export default function HelpCenterPage() {
  const t = HUB_T[useUiLang()];
  return (
    <div className="bg-zinc-50 pt-20 min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-indigo-700 via-purple-700 to-indigo-800 py-16 sm:py-20 text-white text-center px-4">
        <h1 className="text-4xl font-bold mb-4">{t.title}</h1>
        <p className="text-lg max-w-2xl mx-auto">{t.intro}</p>
      </section>

      <section className="py-12 sm:py-16 px-6 max-w-5xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.groups.map((group) => (
            <div
              key={group.title}
              className="bg-white border border-gray-200 rounded-xl p-6 shadow hover:border-indigo-500 transition"
            >
              <h2 className="text-lg font-semibold text-indigo-700 mb-2">
                {group.title}
              </h2>
              <ul className="text-sm text-gray-600 space-y-2">
                {group.links.map(([path, label]) => (
                  <li key={path}>
                    <Link to={`${BASE}/${path}`} className="hover:text-indigo-600">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-indigo-50 py-16 text-center px-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">{t.ctaTitle}</h2>
        <p className="text-gray-600 max-w-xl mx-auto mb-6">{t.ctaText}</p>
        <a
          href="mailto:hello@startupsmartup.com"
          className="inline-block bg-indigo-600 text-white px-8 py-3 rounded-lg font-medium shadow hover:bg-indigo-700"
        >
          {t.cta}
        </a>
      </section>
    </div>
  );
}
